<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Change Password</h5>
        <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="changePasswordForm">
            <div class="form-group" *ngIf="!dialogData?.data">
                <div class="text-box-wrap">
                    <label>Current Password</label>
                    <input type="password" formControlName="oldPassword" class="form-control"
                        [ngClass]="{'is-invalid': formErrors.oldPassword}" maxlength="50">
                    <div class="invalid-feedback" *ngIf="fc.oldPassword.errors && fc.oldPassword.errors.required">Please
                        enter your old
                        password</div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label>New Password </label>
                    <input [type]="showPassword ? 'password' : 'text'" formControlName="password"
                        class="form-control w-95" [ngClass]="{'is-invalid': formErrors.password}" maxlength="50">
                    <i (click)="showPassword = !showPassword" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="showPassword" class="eye-pos fa fa-eye mt-5" aria-hidden="true"></i>
                    <div class="invalid-feedback" *ngIf="fc.password.errors && fc.password.errors.required">Please
                        enter your new password</div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label>Confirm Password</label>
                    <input type="password" formControlName="confirmPassword" class="form-control"
                        [ngClass]="{'is-invalid': formErrors.confirmPassword}" maxlength="50">
                    <div class="invalid-feedback"
                        *ngIf="fc.confirmPassword.errors && fc.confirmPassword.errors.required">Please
                        enter confirm password</div>
                    <div class="invalid-feedback"
                        *ngIf="fc.confirmPassword.errors && fc.confirmPassword.errors.mustMatch">Password &
                        Confirm Password are different</div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDialog()">Close</button>
        <button type="button" (click)="changePassword()" [disabled]="!changePasswordForm.valid"
            class="btn btn-success">Save
            changes</button>
    </div>
</div>